import { motion } from "framer-motion";

const STEPS = [
  { title: "1. Share Your Needs", body: "Tell us your destination, dates, budget, or whether you need ticket and visa assistance." },
  { title: "2. Custom Itinerary", body: "Receive options with transparent pricing, verified hotels, and optimal transit timings." },
  { title: "3. Instant Confirmation", body: "We secure your tickets, process visa applications, and issue confirmed hotel vouchers." },
  { title: "4. Support on the Road", body: "Our desk remains available on call and WhatsApp throughout your journey until you return." },
];

export const Process = () => (
  <section className="py-20 bg-stone-50" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <span className="text-xs font-bold tracking-widest text-amber-800 uppercase">Seamless Process</span>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-stone-900 mt-2 font-serif-display">
          How we get you ready to travel
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="bg-white p-6 rounded-xl border border-stone-200"
            data-testid={`process-step-${i + 1}`}
          >
            <div className="w-3 h-3 rounded-full bg-amber-700 mb-4" />
            <h4 className="text-base font-bold text-stone-900 mb-2">{s.title}</h4>
            <p className="text-xs text-stone-600">{s.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
